import { frontendURL } from '../../../helper/URLHelper';
import Index from '../settings/supportTickets/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/support-tickets'),
      name: 'support_tickets_index',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Index,
    },
  ],
};
